import { render, staticRenderFns } from "./MenuSingle.vue?vue&type=template&id=251cd280&scoped=true&"
import script from "./MenuSingle.vue?vue&type=script&lang=js&"
export * from "./MenuSingle.vue?vue&type=script&lang=js&"
import style0 from "./MenuSingle.vue?vue&type=style&index=0&id=251cd280&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "251cd280",
  null
  
)

export default component.exports